import DrawModeBase from '@/lib/mapbox/draw-mode-base'
import markupService from '@/services/markup-service'

/**
 * Connect mode
 */
class ConnectMode extends DrawModeBase {
  /**
   * @inheritDoc
   */
  toDisplayFeatures(geoJson) {
    const connectionPoints = this._formatConnectPoints(geoJson)
    return [geoJson, ...connectionPoints]
  }

  /**
   * Formats the points where the two lines connect
   * @param {Object} lineGeoJson - The line feature GeoJSON.
   * @returns {Object} Point Feature GeoJson representing the trim start point
   */
  _formatConnectPoints(geoJson) {
    const originalMarkup = markupService.getMarkupByID(geoJson.id)
    const originalCoordinates = originalMarkup.coordinates
    const newCoordinates = geoJson.geometry.coordinates

    const startPoint = newCoordinates[originalCoordinates.length - 1]
    const endPoint = newCoordinates[originalCoordinates.length]
    return [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: startPoint,
        },
        properties: {
          meta: 'connect-point',
        },
      },
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: endPoint,
        },
        properties: {
          meta: 'connect-point',
        },
      },
    ]
  }
}

export default ConnectMode
